import React from 'react';

import Layout from '../components/Layout';
import Scroll from '../components/Scroll';

import config from '../../config';
import Footer from '../components/Footer';
import Header from '../components/Header';
import ScrollToTop from '../components/ScrollToTop';

import p2 from '../assets/images/creativity.jpg';
import p3 from '../assets/images/creative2.gif';

const IndexPage = () => (
  <Layout>
    <Header />

    <div className="col-lg-6">
            <a className="portfolio-item" href="#">
              <span className="caption">
                <span className="caption-content">
                  <h2></h2>
                  <p className="mb-0">
                  <b>Design is an Art !...with just a click</b>
                  </p>
                </span>
              </span>
              <img className="img-fluid" src={p2} alt="" />
            </a>


          </div>

   

     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://canva.com/" className="btn btn-xl btn-light mr-4">
         Create Logo, Flyer, Posts..etc
        </a>
        
      </div>
    </section>






    

    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://thebearandhisscarf.com/" className="btn btn-xl btn-light mr-4">
         The Bear and his Scarf
        </a>
         <a href="https://activetheory.net/home" className="btn btn-xl btn-dark">
         Active Theory
        </a>
      </div>
    </section>







 <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.adobe.com/uk/products/photoshop-elements.html" className="btn btn-xl btn-light mr-4">
         Adobe
        </a>
        <a href="https://affinity.serif.com/en-gb/publisher/" className="btn btn-xl btn-dark">
         Affinity
        </a>
      </div>
    </section>


     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.pixton.com/" className="btn btn-xl btn-light mr-4">
          Pixton Animations
        </a>
        <a href="https://www.animaker.com/cartoon-maker" className="btn btn-xl btn-dark">
          Graphics
        </a>
      </div>
    </section>




 <section className="content-section" id="portfolio">
      <div className="container">
        <div className="content-section-heading text-center">
          <h3 className="text-secondary mb-0">Browse Smartly</h3>
          <img className="img-fluid" src={p3} alt="" />
          <h2 className="mb-5"> Create and innovate on the Internet Smartly..<i className="fab fa-creative-commons-remix fa-spin"></i></h2>
        </div>
        
      </div>
    </section>




 <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://biteable.com/cartoon/" className="btn btn-xl btn-light mr-4">
        Bitable Animations
        </a>
        <a href="https://www.behance.net/" className="btn btn-xl btn-dark">
       Behance
        </a>
      </div>
    </section>





 <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.zulualphakilo.com/" className="btn btn-xl btn-light mr-4">
        Zulualphakilo
        </a>
        <a href="https://www.fcinq.com/" className="btn btn-xl btn-dark">
       Fcinq
        </a>
      </div>
    </section>





     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.xxix.co/" className="btn btn-xl btn-light mr-4">
        XXiX
        </a>
        <a href="https://www.madeinhaus.com/" className="btn btn-xl btn-dark">
      Madeinhaus
        </a>
      </div>
    </section>






     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.pinterest.com/" className="btn btn-xl btn-light mr-4">
         Pinterest
        </a>
        <a href="http://www.webcreme.com/" className="btn btn-xl btn-dark">
         Webcreme
        </a>
      </div>
    </section>



<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.archdaily.com/" className="btn btn-xl btn-light mr-4">
         Archdaily
        </a>
        <a href="
https://www.stinkstudios.com/work/browns-fashion-x-sara-shakeel" className="btn btn-xl btn-dark">
         Stink Studios
        </a>
      </div>
    </section>












    {/* <section id="contact" className="map">
      <iframe
        width="100%"
        height="100%"
        frameborder="0"
        scrolling="no"
        marginheight="0"
        marginwidth="0"
        src="https://maps.google.com/maps?f=q&amp;source=s_q&amp;hl=en&amp;geocode=&amp;q=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;aq=0&amp;oq=twitter&amp;sll=28.659344,-81.187888&amp;sspn=0.128789,0.264187&amp;ie=UTF8&amp;hq=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;t=m&amp;z=15&amp;iwloc=A&amp;output=embed"
      ></iframe>
      <br />
      <small>
        <a href="https://maps.google.com/maps?f=q&amp;source=embed&amp;hl=en&amp;geocode=&amp;q=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;aq=0&amp;oq=twitter&amp;sll=28.659344,-81.187888&amp;sspn=0.128789,0.264187&amp;ie=UTF8&amp;hq=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;t=m&amp;z=15&amp;iwloc=A"></a>
      </small>
    </section> */}

    <ScrollToTop />
    <Footer />
  </Layout>
);

export default IndexPage;
